// src/about/Values.jsx
import React from 'react';
import '../../styles/components/AboutValues.css';

// Прямі імпорти PNG-бейджів з /src/img/value-badges/
import EyeCircle from '../../img/value-badges/EyeCircle-1.png';
import TreeStructureCircle from '../../img/value-badges/TreeStructureCircle-2.png';
import PuzzlePieceCircle from '../../img/value-badges/PuzzlePieceCircle-1.png';
import RocketCircle from '../../img/value-badges/RocketCircle.png';
import WalletCircle from '../../img/value-badges/WalletCircle.png';

// Мапа ім'я -> url (ключі мусять збігатися з полем badge у CARDS)
const BADGES = {
  EyeCircle,
  TreeStructureCircle,
  PuzzlePieceCircle,
  RocketCircle,
  WalletCircle,
};

const CARDS = [
  {
    badge: "EyeCircle",
    title: "Experience",
    text: "Shipping AI-centric products since 2022. We’ve already made the mistakes so you don’t have to.",
    tone: "light",
  },
  {
    badge: "TreeStructureCircle",
    title: "Metrics-Driven",
    text: "We optimize what matters: ARPU, LTV, retention, cost per creative, team size.",
    tone: "brand",
  },
  {
    badge: "PuzzlePieceCircle",
    title: "Focus",
    text: "No need to hire, onboard, and hope. We come ready.",
    tone: "light",
  },
  {
    badge: "RocketCircle",
    title: "Speed",
    text: "We’ve most likely already built a project like yours.",
    tone: "brand",
  },
  {
    badge: "WalletCircle",
    title: "Cost Optimization",
    text: "We know how to scale AI without breaking your unit economics.",
    tone: "light",
  },
];

export default function AboutValues() {
  return (
    <section className="values" aria-labelledby="values-title">
      <h2 id="values-title" className="values-title values-anim">
        Why teams choose us
      </h2>

      <div className="values-grid">
        {CARDS.map((c) => (
          <article
            key={c.title}
            className={`value-card value-card--${c.tone} values-anim`}
            aria-label={c.title}
          >
            {/* PNG-бейдж зверху по центру */}
            <img
              className="value-badge"
              src={BADGES[c.badge]}
              alt=""
              loading="lazy"
              decoding="async"
            />

            <h3 className="value-card__title">{c.title}</h3>
            <p className="value-card__text">{c.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
